{
  "title": "Логи терминала",
  "columns": {
    "session_id": "ID Сессии",
    "ci_name": "Имя CI",
    "host": "Адрес",
    "username": "Пользователь",
    "updated_at": "Дата",
    "actions": "Действия"
  },
  "modal": {
    "title": "Лог терминала"
  }
}